import React, { useState } from "react";
import { toast } from "react-toastify";
import { API } from "../../constants/Api";

function ForgotPasswordTwo({ props }) {
  const [loading, setLoading] = useState(false);

  function formValidations() {
    if (props.otp.length < 1) {
      toast.error("OTP is required");
      return false;
    }

    return true;
  }

  const handleSubmit = async (e) => {
    e.preventDefault(); // Prevent the default form submission behavior
    const isValid = await formValidations();

    if (isValid) {
      props.setIndex(3); // Move to the next step
    }
  };

  return (
    <>
      <form className="agent-register-form" onSubmit={handleSubmit}>
        {/* <input
          type="number"
          className="form-control agent-register-input-field"
          id="exampleInputEmail1"
          placeholder="00 00 00"
          aria-describedby="emailHelp"
          maxLength="6"
          onChange={(e) => props.setOtp(e.target.value)}
        /> */}
        <input
          type="number"
          className="form-control agent-register-input-field"
          id="exampleInputEmail1"
          placeholder="00 00 00"
          aria-describedby="emailHelp"
          maxLength="6"
          min="0"
          max="999999"
          pattern="\d*"
          onChange={(e) => {
            const value = e.target.value.replace(/\D/g, "").slice(0, 6);
            props.setOtp(value);
            e.target.value = value;
          }}
        />
        <label style={{ opacity: "0.8" }} className="code-label">
          6 - Digit code has been sent to your phone number and email.{" "}
          {/* <Link className="text-white">Change Details</Link> */}
        </label>

        <button type="submit" className="btn agent-register-button">
          Verify
        </button>
      </form>
    </>
  );
}

export default ForgotPasswordTwo;
